import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { Section } from '@fiverr-private/layout_components';
import { DEFAULT_FIVERR_LOCALE } from '@fiverr-private/localization';
import { getGigIds as getBrowseHistory } from '../../utils/browsingHistory';
import { PERSONALIZED_CONTENT, PAGE_NAME } from '../../utils/constants/recommendations';
import useTranslationToggle from '../../hooks/useTranslationToggle';
import { TranslationContextProvider } from '../../context/TranslationContext';
import MachineTranslationButtonWrapper from '../../shared/MachineTranslationButtonWrapper';
import PersonalizedSection from './PersonalizedSection';

import styles from './styles.module.scss';

const PersonalizedSectionWrapper = () => {
    const { onTranslationToggle, setOriginalContent, translationState } = useTranslationToggle();
    const { personalizedContentMap, showTranslatedContent, isInitialized } = translationState;
    const { locale } = getContext();
    const recommendationsParams = {
        browse_history: getBrowseHistory(),
        pageName: PAGE_NAME,
        funnelName: PERSONALIZED_CONTENT.FUNNEL_NAME,
    };

    const showTranslationButton = locale !== DEFAULT_FIVERR_LOCALE;

    return (
        <TranslationContextProvider
            value={{
                personalizedContentMap,
                showTranslatedContent,
                isInitialized,
                setOriginalContent,
                onTranslationToggle,
            }}
        >
            <Section paddingTop="0" paddingBottom="0">
                <div className={styles.personalizedSectionWrapper}>
                    {showTranslationButton && <MachineTranslationButtonWrapper />}
                    <PersonalizedSection recommendationsParams={recommendationsParams} />
                </div>
            </Section>
        </TranslationContextProvider>
    );
};

export default PersonalizedSectionWrapper;
